import React, {useEffect, useState} from 'react';

const Ico2 = (props) => {
    const [x,setX]= useState(0)
    useEffect(()=>{

        const interv = setInterval(()=>{
            setX((xx)=>{
                return xx+0.1
            })
            // clearInterval(interv)
        },10)
        return ()=>{
            clearInterval(interv)
        }
    },[])
    return (

    <svg width='100%' style={{transform:`rotate(${x}deg)`}}  viewBox="0 0 206 212" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
            <path d="M178.565 111.906C178.946 108.731 179.2 105.429 179.2 102C179.2 98.5709 178.946 95.2689 178.438 92.0939L199.901 75.3299C201.806 73.8059 202.314 71.0119 201.171 68.8529L180.851 33.6739C179.581 31.3879 176.914 30.6259 174.628 31.3879L149.355 41.5479C144.021 37.4839 138.433 34.1819 132.21 31.6419L128.4 4.71794C128.019 2.17794 125.86 0.39994 123.32 0.39994H82.6798C80.1398 0.39994 78.1078 2.17794 77.7268 4.71794L73.9168 31.6419C67.6938 34.1819 61.9788 37.6109 56.7718 41.5479L31.4988 31.3879C29.2128 30.4989 26.5458 31.3879 25.2758 33.6739L4.95583 68.8529C3.68583 71.1389 4.19383 73.8059 6.22583 75.3299L27.6888 92.0939C27.1808 95.2689 26.7998 98.6979 26.7998 102C26.7998 105.302 27.0538 108.731 27.5618 111.906L6.09883 128.67C4.19382 130.194 3.68583 132.988 4.82883 135.147L25.1488 170.326C26.4188 172.612 29.0858 173.374 31.3718 172.612L56.6448 162.452C61.9788 166.516 67.5668 169.818 73.7898 172.358L77.5998 199.282C78.1078 201.822 80.1398 203.6 82.6798 203.6H123.32C125.86 203.6 128.019 201.822 128.273 199.282L132.083 172.358C138.306 169.818 144.021 166.389 149.228 162.452L174.501 172.612C176.787 173.501 179.454 172.612 180.724 170.326L201.044 135.147C202.314 132.861 201.806 130.194 199.774 128.67L178.565 111.906ZM103 140.1C82.0448 140.1 64.8998 122.955 64.8998 102C64.8998 81.0449 82.0448 63.8999 103 63.8999C123.955 63.8999 141.1 81.0449 141.1 102C141.1 122.955 123.955 140.1 103 140.1Z" fill="url(#paint0_radial)"/>
        </g>
        <defs>
            <filter id="filter0_d" x="0.224365" y="0.39994" width="205.551" height="211.2" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset dy="4"/>
                <feGaussianBlur stdDeviation="2"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
            <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(103 102) rotate(90) scale(101.6 98.7755)">
                <stop stopColor="#FF5CD1"/>
                <stop offset="1" stopColor="#5A2323" stopOpacity="0.16"/>
            </radialGradient>
        </defs>
    </svg>




);
};

export default Ico2;